import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Spin } from "antd";

let instance = null;
let times = 0;

class WeaLoadingGlobal extends Component {
  state = {
    spinning: true,
    size: "large"
  };
  render() {
    return (
      <div className="wea-loading-global">
        <Spin {...this.state} {...this.props}>
          <div className="wea-loading-global-content ant-spin-blur" />
        </Spin>
      </div>
    );
  }
}

function newInstance(props = {}, callback) {
  const div = document.createElement("div");
  document.body.appendChild(div);
  function ref(spin) {
    callback({
      component: spin,
      destroy() {
        ReactDOM.unmountComponentAtNode(div);
        document.body.removeChild(div);
      }
    });
  }
  ReactDOM.render(<WeaLoadingGlobal ref={ref} {...props} />, div);
}

function getInstance(props, callback) {
  times++;
  if (instance) {
    callback(instance);
    return;
  }
  newInstance(props, ins => {
    if (instance) {
      callback(instance);
      return;
    }
    instance = ins;
    callback(ins);
  });
}

export default {
  start(props) {
    if (instance) {
      instance.component.setState({ spinning: true });
    } else {
      times === 0 && getInstance(props, function() {});
    }
  },
  end() {
    if (instance) {
      instance.component.setState({ spinning: false });
    }
  },
  destroy() {
    if (instance) {
      instance.destroy();
      instance = null;
      times = 0;
    }
  }
};



// WEBPACK FOOTER //
// ./ecology9/wea-loading-global/index.js